















import { Component, Prop, Vue } from 'vue-property-decorator';
// import { TimelineItem } from 'element-ui';
@Component({
  name: 'lb-timeline-item'
  // components: {
  //   'el-timeline-item': TimelineItem
  // }
})
export default class extends Vue {
  @Prop() private timestamp!: string;
  @Prop({ type: Boolean, default: false }) private hideTimestamp!: boolean;
  @Prop({ default: 'top' }) private placement!: string;
  @Prop() private type!: string;
  @Prop() private color!: string;
  @Prop({ default: 'normal' }) private size!: string;
  @Prop() private icon!: string;
}
